const cards = [
  {
    id: 1,
    title: '每日大赛官方网站入口（最新可用）',
    summary: '经过实时验证的每日大赛官方网址，确保您能顺利访问平台，体验全部功能与赛事内容。',
    tag: '官方入口',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20workspace%20setup%20with%20a%20laptop%20displaying%20abstract%20content%20on%20screen%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20clean%20wooden%20desk%20surface%2C%20soft%20shallow%20depth%20of%20field%2C%20professional%20yet%20inviting%20atmosphere%2C%20warm%20neutral%20tones%20with%20subtle%20golden%20accents&width=800&height=500&seq=cards-01&orientation=landscape',
  },
  {
    id: 2,
    title: '每日大赛备用网址与镜像站点汇总',
    summary: '当主站访问受限时，我们提供多个备用入口和镜像站点，确保您随时都能连接每日大赛。',
    tag: '备用入口',
    tagColor: 'bg-accent-100 text-accent-700',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20digital%20network%20visualization%20with%20interconnected%20nodes%20and%20glowing%20pathways%2C%20abstract%20technology%20concept%2C%20warm%20amber%20and%20soft%20coral%20color%20palette%2C%20clean%20minimal%20background%2C%20modern%20tech%20aesthetic%20with%20subtle%20depth&width=800&height=500&seq=cards-02&orientation=landscape',
  },
  {
    id: 3,
    title: '每日大赛APP最新版本下载指南',
    summary: '提供iOS与Android双平台每日大赛APP下载方式，包含安装教程与常见问题解决方案。',
    tag: 'APP下载',
    tagColor: 'bg-primary-100 text-primary-700',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20vibrant%20app%20interface%20with%20colorful%20cards%20on%20screen%2C%20resting%20on%20a%20clean%20white%20surface%2C%20surrounded%20by%20soft%20natural%20light%2C%20minimalist%20product%20photography%20style%2C%20warm%20neutral%20background%20with%20gentle%20shadows&width=800&height=500&seq=cards-03&orientation=landscape',
  },
  {
    id: 4,
    title: '每日大赛最新网址更新公告',
    summary: '实时追踪每日大赛官方网址变更动态，第一时间发布更新通知，帮助用户及时获取最新访问入口。',
    tag: '网址更新',
    tagColor: 'bg-secondary-100 text-secondary-800',
    image: 'https://readdy.ai/api/search-image?query=A%20notification%20bell%20icon%20with%20glowing%20effect%20on%20an%20abstract%20digital%20dashboard%2C%20warm%20lighting%2C%20modern%20UI%20design%20elements%2C%20clean%20background%20with%20soft%20gradients%2C%20professional%20tech%20aesthetic%2C%20attention%20grabbing%20yet%20elegant%20composition&width=800&height=500&seq=cards-04&orientation=landscape',
  },
  {
    id: 5,
    title: '每日大赛注册与使用教程',
    summary: '为新用户提供详细的注册流程指南、平台功能介绍与使用技巧，帮助您快速上手每日大赛。',
    tag: '新手指南',
    tagColor: 'bg-accent-100 text-accent-700',
    image: 'https://readdy.ai/api/search-image?query=A%20friendly%20guidebook%20and%20magnifying%20glass%20on%20a%20warm%20desk%20setting%2C%20soft%20natural%20light%20streaming%20in%2C%20clean%20organized%20workspace%2C%20inviting%20and%20helpful%20atmosphere%2C%20minimalist%20composition%20with%20warm%20neutral%20tones&width=800&height=500&seq=cards-05&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            赛事速递
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日大赛最新入口资讯与实用指南，一站式获取访问所需全部信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <article
              key={card.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-0.5 text-xs font-semibold rounded-full mb-3 ${card.tagColor}`}>
                  {card.tag}
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {card.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}